export function formatVigency(vigency: string) {
  const value = parseInt(vigency);
  return `${value} ${value === 1 ? 'Mes' : 'Meses'}`;
}
